import layout from '../layout'
export default function makeCrudRoutes({
  contentType,
  components: { PromoListingContainer }
}) {

  return [
    {
      path: '/',
      component: layout,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: `/${contentType.name}/list`,
          component: PromoListingContainer,
          props: {
            contentType
          }
        }
      ]
    }
  ];
}
